<template>
  <div class="page__sidebar h-100">
    <component
      :is="sideBar"
      :counters="allCounters"
      :options="options"
      :selected-option="selectedOption"
      :store="store"
      :disable-add-filter="disableAddFilter"
      :custom-options="customOptions"
      @expand="expand"
      @setDefaultOptionParent="setDefaultOption($event)"
      @contract="contract"
      @update:selected-option="changeSelectedOption"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="removeCustomOption"
      @rename-option="showRenameModal"
      @update-option="showUpdateModal"
    />
    <modal-confirmation
      id="studySideBarConfirmationModal"
      ref="confirmationModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import store from './registryCaseSideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'
import CaseServices from '@/modules/RegistryModule/services/registryCaseServices'

export default {
    name: 'RegistryCaseSideBar',
    components: {
        ModalConfirmation,
        RenameCustomFilterModal
    },
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return this.state.options
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        cardIndexRouteName() {
            return this.state.cardIndexRouteName
        },
        allCounters() {
            return this.counters
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    async created() {
        await this.updateLastModified()
        this.$emit('updateSummary')
    },
    methods: {
        async changeSelectedOption(value) {
            if (value.isCase && this.$route.params.id !== value.id) {
                this.$router.push({ name: 'registryEditCase', params: { id: value.id } })
            } else if (!value.isCase && this.$route.name !== 'caseGrid') {
                this.$router.push({ name: 'caseGrid', params: { fromForm: true } })
            }
            store.setSelectedOption(value)
            this.$emit('changed-option', value)
        },
        async updateLastModified() {
            let lastModified = await CaseServices.lastModifiedCases(this.labId)
            lastModified.forEach((studyCase) => { studyCase.isCase = true })
            this.updateSideBarOptionChildren(this.store.state.options.expanded, 'lastCases', lastModified)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        removeCustomOption(option) {
            this.$refs.confirmationModal.ask(() => {
                store.removeCustomOption(option)
                this.showToastSuccessGlobal(this.$t('global.filterDeleted'))
            })
        },
        showRenameModal(option) {
            this.$refs.renameModal.show(option)
        },
        showUpdateModal(option) {
            this.$refs.confirmationModal.ask(() => {
                this.$emit('update-option', option)
            })
        },
        renameCustomOption(option) {
            store.renameCustomOption(option)
            this.showToastSuccessGlobal(this.$t('global.renamedFilter'))
        },
        updateCustomOption(option) {
            store.updateCustomOption(option)
        },
        expand() {
            store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        contract() {
            store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        setDefaultOption(ev) {
            store.setDefaultOption(ev)
            store.saveConfig()
        }
    }
}

</script>
